import { render, staticRenderFns } from "./shopping-cart-total.vue?vue&type=template&id=ba33cdf0"
import script from "./shopping-cart-total.vue?vue&type=script&lang=js"
export * from "./shopping-cart-total.vue?vue&type=script&lang=js"
import style0 from "./shopping-cart-total.vue?vue&type=style&index=0&id=ba33cdf0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports